import postsData from "@/content/blog-posts.json";

export type BlogPost = {
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  readingTime: string;
  publishedAt: string;
  featuredImage: string;
};

export const SITE_ORIGIN = "https://finendra.com";

export const blogPosts = postsData as BlogPost[];

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}

/** Per-post social card, rendered from the post title, excerpt and featured image. */
export function blogOgImageUrl(slug: string, theme: "light" | "dark" = "light"): string {
  return theme === "dark"
    ? `${SITE_ORIGIN}/og/blog/dark/${slug}.png`
    : `${SITE_ORIGIN}/og/blog/${slug}.png`;
}

export function blogPostUrl(slug: string): string {
  return `${SITE_ORIGIN}/blog/${slug}`;
}

/** og:/twitter: meta entries for a blog post, derived from its own content. */
export function blogPostSocialMeta(post: BlogPost) {
  const image = blogOgImageUrl(post.slug);
  const imageDark = blogOgImageUrl(post.slug, "dark");
  return [
    { property: "og:image", content: image },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: post.title },
    { property: "og:image:dark", content: imageDark },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: post.title },
    { name: "twitter:description", content: post.excerpt },
    { name: "twitter:image", content: image },
    { name: "twitter:image:alt", content: post.title },
  ];
}
